// Picker-only grouping. Never rewrite stored species IDs or the source catalogue.
import { NAMED_CULTIVARS, normalizeCultivar, cultivarMatches } from './cultivars';
const normalize = value => String(value || '').trim().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
export const pickerSpeciesKey = id => ({ cherrytomat: 'tomat', tomato: 'tomat', 'cherry-tomato': 'tomat' }[id] || id);

export function speciesVarieties(species, serverCatalog, presets) {
  const key = pickerSpeciesKey(species);
  const known = serverCatalog?.[key]?.varieties;
  const existing = Array.isArray(known) && known.length ? known : (presets[key] || []).map(label => ({ key: label, label }));
  const merged = new Map(existing.map(option => [normalizeCultivar(option.label), option]));
  for (const option of NAMED_CULTIVARS[key] || []) {
    const id = normalizeCultivar(option.label);
    merged.set(id, { ...merged.get(id), ...option });
  }
  return [...merged.values()];
}

export function pickerCatalog(catalog, { search = '', category = 'all', varieties = {} } = {}) {
  const query = normalize(search);
  return catalog.filter(plant => pickerSpeciesKey(plant.id) === plant.id)
    .filter(plant => category === 'all' || plant.cat === category)
    .filter(plant => !query || (varieties[plant.id] || NAMED_CULTIVARS[plant.id] || []).some(option => cultivarMatches(option, search)) || catalog.some(alias => pickerSpeciesKey(alias.id) === plant.id
      && [alias.id, alias.scientific_name, ...Object.values(alias.name || {})].some(name => normalize(name).includes(query))));
}
